<template>
  <div class="Dashboard">
    <Breadcrumbs />
    <dashboard-top>
      <div class="category-selector">
        <svg-icon icon="ball"></svg-icon>
        <div class="category-selector__name">
          {{ selectedEventName }}
        </div>
        <Dropdown
          :items="eventFilterOptions"
          prop="name"
          keyProp="id"
          @dropdown-item-click="changeEventFilter" />
      </div>
      <screen-title :title="this.$store.state.user.team.name"> </screen-title>
      <div
        class="btn btn--primary"
        v-if="userIs('admin')"
        @click="showImportModal">
        Add New players
      </div>
    </dashboard-top>

    <div class="container-full">
      <section-title title="All Registered Players">
        <Search @searched="handleSearch" />
        <Dropdown
          :items="sortOptions"
          type="action"
          @dropdown-item-click="handleSortChange">
          <action icon="sort"></action>
        </Dropdown>

        <Dropdown
          :items="exportOptions"
          keyProp="id"
          class="ml-8"
          prop="label"
          align="right"
          type="action"
          @dropdown-item-click="handleExportOption">
          <action icon="download" />
        </Dropdown>

        <div class="ml-8" v-if="userIs('admin')">
          <action icon="upload-cloud" @actionClicked="showImportModal"></action>
        </div>
      </section-title>

      <fade-transition mode="out-in">
        <TableLoader v-if="!loaded" />

        <Table
          :items="players"
          :search-query="searchQuery"
          :key="(players ? players.length : 0) + '-' + selectedEventId"
          :sort="sortPlayersBy"
          v-if="loaded && players.length > 0"
          paginationHistory />

        <empty-message v-if="loaded && players.length == 0"
          >No players found</empty-message
        >
      </fade-transition>
    </div>

    <ImportPlayersModal
      v-if="showImport"
      :toggle="hideImportModal"
      showAddPlayer />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { saveAs } from 'file-saver';
  import moment from 'moment';
  import TableLoader from '@/components/Loaders/TableLoader';
  import Table from '@/components/Tables/PlayersTable';
  import ImportPlayersModal from '@/components/Modals/ImportPlayersModal';

  import SearchMixin from '@/mixins/SearchMixin';

  export default {
    name: 'Players',
    mixins: [SearchMixin],
    data: function () {
      return {
        showImport: false,
        selectedEventId: null,
        sortPlayersBy: {
          sortedBy: null,
          status: 0,
        },
        sortOptions: [
          { label: 'Sort By Name', value: 'name' },
          { label: 'Sort By Rating', value: 'average_rating.0.rating' },
          { label: 'Sort By Birthday', value: 'birthday' },
          { label: 'Reset sorting', value: 'reset' },
        ],
        exportOptions: [
          { id: 'export', label: 'Export Players as CSV' },
          { id: 'notes', label: 'Export Notes as CSV' },
          { id: 'template', label: 'Download Import Template' },
        ],
      };
    },
    components: {
      Table,
      TableLoader,
      ImportPlayersModal,
    },
    mounted() {
      this.$store.dispatch('players/GET_PLAYERS');
      if (!this.$store.state.events.all) {
        this.$store.dispatch('events/GET_EVENTS');
      }
    },
    methods: {
      changeEventFilter(payload) {
        this.selectedEventId = payload.id;
        if (payload.id) {
          this.$store.dispatch('players/GET_PLAYERS', {
            event_id: payload.id,
          });
        } else {
          this.$store.dispatch('players/GET_PLAYERS');
        }
      },
      handleSortChange(payload) {
        let isReset = payload.value === 'reset';
        let status = isReset
          ? 0
          : payload.value !== this.sortPlayersBy.sortedBy
          ? 1
          : this.sortPlayersBy.status < 2
          ? 2
          : 0;
        this.sortPlayersBy = {
          sortedBy: payload.value,
          status: status,
        };
      },
      handleExportOption(option) {
        const eventId = this.selectedEventId;
        const prefix = eventId ? `${this.selectedEventName} - ` : '';
        const exports = {
          export: eventId
            ? ['events/EXPORT_EVENT', { eventId, type: 'players' }]
            : ['players/EXPORT_PLAYERS'],
          notes: eventId
            ? ['events/EXPORT_EVENT_NOTES', eventId]
            : ['players/EXPORT_NOTES'],
          template: ['players/DOWNLOAD_TEMPLATE'],
        };
        const date = moment().format('YYYY-MM-DD');
        const filenames = {
          export: `${prefix}Players Export ${date}.csv`,
          notes: `${prefix}Notes ${date}.csv`,
          template: 'Players Import Template.csv',
        };
        this.$store.dispatch(...exports[option.id]).then((res) => {
          if (!res) return;
          const blob = new Blob([res.body], { type: 'text/csv' });
          saveAs(blob, filenames[option.id]);
        });
      },
      showImportModal() {
        this.showImport = true;
      },
      hideImportModal() {
        this.showImport = false;
      },
    },
    computed: {
      ...mapState({
        players: (state) => state.players.all,
        loaded: (state) => state.players.status.all == 'success',
        events: (state) => state.events.all,
      }),
      selectedEventName() {
        if (!this.selectedEventId) return 'All Events';
        const event =
          this.events && this.events.find((e) => e.id == this.selectedEventId);
        return event ? event.name : 'All Events';
      },
      eventFilterOptions() {
        const options = [{ id: null, name: 'All Events' }];
        if (this.events) {
          return options.concat(
            this.events.filter((e) => e.id != this.selectedEventId),
          );
        }
        return options;
      },
    },
  };
</script>
